const chatEnd = {
  validate: () => true,
  render: () => ({ stayInCurrentStep: true }),
};

export default chatEnd;
